import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const StrategyPage = lazy(() => import('../pages/strategy/page'));
const SocialMediaPage = lazy(() => import('../pages/social-media/page'));
const InfluencerKayitPage = lazy(() => import('../pages/influencer-kayit/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/strategy',
    element: <StrategyPage />,
  },
  {
    path: '/social-media',
    element: <SocialMediaPage />,
  },
  {
    path: '/influencer-kayit',
    element: <InfluencerKayitPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
